export default {
  REGISTER_WIDTH(state, widthCards) {
    state.widthCards = widthCards;
  },
  ALTER_SIZE_MODAL(state, item) {
    state.sizeModal = item;
  },
  ALTER_SIZE_MODAL_REGISTER(state, item) {
    state.sizeModalRegister = item;
  },
  ALTER_MODAL_CONTAINER_GENERAL(state, item) {
    state.modalContainerGeneral = item
  },
  ALTER_MODAL_CONTAINER_REGISTER(state, item) {
    state.modalContainer = item
  },
  ALTER_TYPE_REGISTER(state, item) {
    state.typeRegister = {
      course: false,
      detailsCourse: false,
      [item]: true,
    };
  },
  SET_COLAPSE_REGISTER(state, item) {
    state.colapseRegister = item
  },
  SET_COLAPSE_GENERAL(state, item) {
    state.colapseGeneral = item
  },
  SET_DATA_SEARCH_FROM_COURSE(state, payload) {
    state.dataSearchCourse = payload
  },
  SET_DATA_SEARCH_FROM_USER(state, payload) {
    state.dataSearchUser = payload
  },
  SET_DATA_SEARCH_FROM_REGISTRATION(state, payload) {
    state.dataSearchRegistration = payload
  },
  SET_DATA_SEARCH_FROM_STUDENT(state, payload) {
    state.dataSearchStudent = payload
  },
  SET_IS_SEARCH_REGISTERS(state) {
    state.isSearchRegisters = !state.isSearchRegisters
  },
};
